function fn_comp_detail_info() {
    var $fn = $(".comp_detail_info"),
        $carousel_nav = $fn.find("[data-carousel-nav]"),
        $carousel_images = $fn.find("[data-carousel-images]");

    if ($fn.length) {
        $carousel_nav.find(".icon--arrow-left").on("click", function(e) {
            e.preventDefault();
            $carousel_images.slick("slickPrev");
        });

        $carousel_nav.find(".icon--arrow-right").on("click", function(e) {
            e.preventDefault();
            $carousel_images.slick("slickNext");
        });
    }
}